import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectWorkersInfo } from "../../selectors/selectWorkersInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TextLoca } from "../generic/text/TextLoca";
var normal = IdStyles.TextNormal;
var _HudWorkerTooltip = function (_a) {
    var free = _a.free, total = _a.total;
    return (React.createElement("div", { className: "HudWorkerTooltip" },
        React.createElement("header", { className: "HudWorkerTooltip__header" },
            React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: IdLoca.help_workers_title })),
        React.createElement("div", { className: "HudWorkerTooltip__info" },
            React.createElement("div", { className: "HudWorkerTooltip__entry" },
                React.createElement("div", { className: "HudWorkerTooltip__entry-item" },
                    React.createElement(TextLoca, { className: normal, id: IdLoca.help_workers_desc1 })),
                React.createElement("div", { className: normal + " HudWorkerTooltip__entry-value" }, total)),
            React.createElement("div", { className: "HudWorkerTooltip__entry HudWorkerTooltip__entry--busy" },
                React.createElement("div", { className: "HudWorkerTooltip__entry-item" },
                    React.createElement(TextLoca, { className: normal, id: IdLoca.help_workers_desc2 })),
                React.createElement("div", { className: normal + " HudWorkerTooltip__entry-value" }, free - total)),
            React.createElement("hr", { className: "HudWorkerTooltip__horizontal-rule" }),
            React.createElement("div", { className: "HudWorkerTooltip__entry" },
                React.createElement("div", { className: "HudWorkerTooltip__entry-item" },
                    React.createElement(TextLoca, { className: normal, id: IdLoca.help_workers_desc3 })),
                React.createElement("div", { className: normal + " HudWorkerTooltip__entry-value" }, free)))));
};
export var HudWorkerTooltip = connect(selectWorkersInfo)(_HudWorkerTooltip);



//////////////////
// WEBPACK FOOTER
// ./src/features/workers/HudWorkerTooltip.tsx
// module id = 2310
// module chunks = 3